
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer/[referralCode]/live/[liveEventId]",
      function () {
        return require("private-next-pages/refer/[referralCode]/live/[liveEventId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer/[referralCode]/live/[liveEventId]"])
      });
    }
  